export const FOR_YOU_FORM_LABELS = {
    budget: "Budżet",
    creditPlan: "Planuję zakup mieszkania na kredyt",
    rooms: "Pokoje",
    regionSearch: "W jakim miejscu chcesz mieszkać?"
};

export const FOR_YOU_ADDITIONAL_FORM_LABELS = {
    additional_areas: "Powierzchnie dodatkowe",
    kitchen: "Typ kuchni",
    floor: "Piętra",
    date: "Data oddania",
    quarters: "Strona świata",
    message: "Twoje dodatkowe uwagi"
};
